import t from "./ghl-ui.es407.js";
function i(n) {
  return n && n.length ? t(n) : [];
}
export {
  i as default
};
